<template>
  <div class="relative h-screen">
    <AppNotifications />
    <div
      class="flex overflow-hidden"
      :class="[showBanner ? 'h-[calc(100vh-94px)]' : 'h-screen']"
    >
      <div
        class="w-full bg-white flex-1 overflow-hidden"
      >
        <div class="bg-gray-100 relative h-full ml-auto transition-all duration-300 ease-in-out">
          <div
            class="overflow-y-auto overflow-x-hidden h-[calc(100vh)]"
          >
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNotifications from "@/Common/Notifications.vue";
  export default {
    components: {
      AppNotifications
    }
  };
  </script>
  
  <style scoped>
  ::-webkit-scrollbar-track {
    background-color: #f5f5f5;
    border-radius: 0px !important;
  }
  
  ::-webkit-scrollbar {
    width: 6px;
    border-radius: 0px !important;
    background-color: #F5F5F5;
  }
  
  ::-webkit-scrollbar-thumb {
    border-radius: 0px !important;
    background-color: #bebebe;
  }
  </style>